import { useGetUserCardTxs as useGetUserCardTxsQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetUserCardTxsProps = {
  cardId: number;
  pageNum?: number;
  pageSize?: number;
  orderNo?: string;
  startTime?: number;
  endTime?: number;
  type?: 'CREATE' | 'DEPOSIT' | 'CANCEL' | 'FREEZE' | 'UNFREEZE' | 'WITHDRAW';
};

/* Hook */
export const useGetUserCardTxs = ({
  cardId,
  pageNum = 1,
  pageSize = 10,
  orderNo,
  startTime,
  endTime,
  type,
}: UseGetUserCardTxsProps) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const { data, isLoading, isError, error } = useGetUserCardTxsQuery({
    enabled: !!id && !!cardId,
    userId: id ?? 0,
    cardId: cardId ?? 0,
    requestData: {
      pageNum,
      pageSize,
      orderNo,
      startTime,
      endTime,
      type,
    },
  });

  /* Return */
  return {
    isLoading,
    isError,
    error,
    total: data?.total,
    records: data?.records,
  };
};
